module.exports = __webpack_public_path__ + "media/images/mobile/solutions/explr-bg4-cbf8ed1a3eb2614855322396d979d8fc.png";